import { render } from "./DocumentView.vue?vue&type=template&id=0a3939dc&scoped=true"
import script from "./DocumentView.vue?vue&type=script&lang=js"
export * from "./DocumentView.vue?vue&type=script&lang=js"

import "./DocumentView.vue?vue&type=style&index=0&id=0a3939dc&scoped=true&lang=scss"

import exportComponent from "/builds/angeloferraro/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a3939dc"]])

export default __exports__